<template>
    <el-dialog
    :title="$t('popper_title.ai_materials_list')"
    :visible="true"
    @close="onclose"
    :append-to-body="true"
    :close-on-click-modal="false"
    width="740px"
    custom-class="codelab-popper ai-materials-popper"
    >
    <p class="tips">
        {{$t("text.ai_material_list_tip")}}
    </p>
    <div class="search-box" @click.stop>
        <el-input v-model.lazy="keyword" class="keyword-inputer" @focus="toggleSearchList(true)">
            <i
                v-if="keyword"
                class="el-input__icon el-icon-close"
                slot="prefix"
                @click="keyword = ''"
            ></i>
            <i v-else class="el-input__icon el-icon-search" slot="prefix"></i>
            <i class="el-input__icon el-icon-caret-bottom" slot="suffix" @click.stop="toggleSearchList(!searchListVisible)"></i>
        </el-input>
        <div class="serch-suggestions" v-if="searchListVisible">
            <p v-if="noSuggestions" class="no-suggestion-tip">{{$t("message.info_no_search_ai_materials")}}</p>
            <el-tag 
            v-for="item in tagsInSearchArea" 
            :key="item.materialId" 
            :class="{'ai-material-tag':true, disabled: item.disabled, active: selectedMaterialIds.includes(item.materialId)}" 
            @click="toggleSelect(item, true)"
            type="info"
            effect="plain"
            >{{item.title}}</el-tag>
            <el-tag 
            v-for="item in searchSuggestions" 
            :key="item.materialId" 
            :class="{'ai-material-tag':true, disabled: item.disabled, active: selectedMaterialIds.includes(item.materialId)}" 
            @click="toggleSelect(item, true)"
            type="info"
            effect="plain"
            >{{item.title}}</el-tag>
        </div>
    </div>
    <div class="typed-material-list">
        <el-scrollbar v-if="categories.length > 0" ref="scrollbar">
            <material-list :data="categories" :selections="selectedMaterialIds" @change="currentCategoryChange" @select="toggleSelect"></material-list>
        </el-scrollbar>
        <list-empty v-else-if="noData"></list-empty>
    </div>
    
    <div slot="footer" class="footer-button-group">
        <button
            class="codelab-button popper-footer-button gray"
            @click="onclose"
        >
            {{ $t("button.cancel") }}
        </button>
        <button
            class="codelab-button popper-footer-button blue"
            :class="{ disabled: !canConfirm }"
            @click="confirm()"
        >
            {{ $t("code-lab/component/connection/set-device-play.vue_10") }}
        </button>
    </div>
    </el-dialog>
</template>
<script>
import materialList from './material-list.vue'
import listEmpty from "@/code-lab/component/list-empty.vue";
import { mapState } from 'vuex';
export default {
    name: "ai-materials",
    components: {
        materialList,
        listEmpty
    },
    data(){
        return {
            searchSuggestions: [],
            categories: [],
            aiMaterials: [],
            query: null,
            selectedMaterials: [],
            keyword: "",
            getSuggestionTimer: null,
            noData: false,
            searchListVisible: false
        }
    },
    computed: {
        ...mapState('user', [
            'teamId',
            'token'
        ]),
        tagsInSearchArea(){
            return this.selectedMaterials.filter(item => !this.searchSuggestions.find(su => su.materialId === item.materialId))
        },
        selectedMaterialIds(){
            return this.selectedMaterials.map(item => item.materialId)
        },
        noSuggestions(){
            return this.keyword && this.searchSuggestions.length === 0
        },
        canConfirm(){
            return this.selectedMaterialIds.length > 0;
        },
         ...mapState({
            //素材区已有的数据
            materialAreaList: state => state.materialsList || []
        }),
    },
    watch: {
        keyword(value){
            if(this.getSuggestionTimer){
                clearTimeout(this.getSuggestionTimer)
                this.getSuggestionTimer = null
            }
            if(value){
                this.getSuggestionTimer = setTimeout(() => {
                    this.getMaterialsByKeyword(value)
                }, 200)
            } else {
                this.searchSuggestions = []
            }
        },
        categories(){
            this.$nextTick(() => {
                this.$refs.scrollbar && this.$refs.scrollbar.update();
            })
        }
    },
    created(){
        this.getMaterialCategories(() => {
            if(this.categories.length === 0){
                this.noData = true
            }
        })
    },
    mounted(){
        this.$nextTick(() => {
            document.body.addEventListener('click', () => {
                this.toggleSearchList(false)
            })
        })
    },
    methods: {
        getMaterialCategories(next = () => {}){
            console.log("get material categories");
            this.http$(
                "get",
                "/developTool/material/categories",
                {
                    type: 'aiObject',
                    customerId: this.teamId,
                    page: 1,
                    limit: 0
                },
                null,
                {
                    Authorization: "Bearer " + this.token
                }
            ).then(res => {
                console.log("categories:", res.data)
                if(res.data && res.data.data && res.data.data.payload){
                    this.categories = res.data.data.payload.map(item => {
                        return Object.assign(item, {title: this.util$.getI18nLabel$(item.i18n, 'langCode', 'description')})
                    })
                } else {
                    this.categories = [];
                }
                next();
            }).catch(err => {
                console.error("get material category error:", err);
                this.categories = [];
                next();
            })
        },
        getMaterialsByKeyword(keyword){
            this.getMaterialList({keyword, limit: 30, page: 1}, res => {
                if(res){
                    res = res.filter(item => !this.selectedMaterialIds.includes(item.materialId))
                    this.searchSuggestions = res
                } else {
                    this.searchSuggestions = []
                }
            })
        },
        getMaterialList({category, keyword, limit = 0, page = 1}, callback = () => {}){
            let query = {
                 customerId: this.teamId, 
                 type: "aiObject", 
                 limit, 
                 page
            };
            if(this.keyword){
                query.keyword = keyword;
            } 
            if(category){
                query.category = category
            }
            this.http$('get', '/developTool/materials', query, null, {
                Authorization: "Bearer " + this.token
            }).then(res => {
                console.log("get ai materials:", res)
                if(res.data && res.data.status && res.data.status.code === "0" && res.data.data){
                    const payload = res.data.data.payload || []
                    callback(payload.map(item => {
                        return Object.assign(item, {
                            title: this.util$.getI18nLabel$(item.metadata.i18n, 'langCode', 'name') || item.metadata.title,
                            disabled: this.isInMaterialArea(item.materialId)
                        })
                    }));
                } else {
                    callback(null);
                }
            }).catch(err => {
                console.error("get ai materials error:", err);
                callback(null);
            })
        },
        toggleSearchList(visible){
            this.searchListVisible = visible
        },
        currentCategoryChange(materialCategoryId){
            const category = this.categories.find(item => item.materialCategoryId === materialCategoryId)
            if(category && !category.materials){
                this.getMaterialList({category: materialCategoryId}, res => {
                    if(res){
                        this.$set(category, 'materials', res)
                    }
                })
            }
            this.$nextTick(() => {
                this.$refs.scrollbar && this.$refs.scrollbar.update();
            })
        },
        //素材选中
        toggleSelect(material, fromSearch = false){
            const {
                materialId,
                disabled
            } = material
            if(disabled){
                return
            }
            if(this.selectedMaterials.find(item => item.materialId === materialId)){
                this.selectedMaterials = this.selectedMaterials.filter(item => item.materialId !== materialId)
            } else {
                this.selectedMaterials.push(material)
            }
            if(!fromSearch){
                //如果點擊的不是搜索區的素材
                this.keyword = ''
            }
            
        },
        isInMaterialArea(materialId) {
            return this.materialAreaList.find(item => item.ref === materialId) ? true : false;
        },
        confirm(){
            if(!this.canConfirm){
                return;
            }
            const data = this.selectedMaterialIds.map(materialId => ({materialId}))
            if(data.length > 0){
                this.$emit("confirm", {
                    type: "aiObject",
                    method: "add",
                    data
                });
            }
            this.onclose();
        },
        onclose(){
            this.$emit('close')
        }
    },
    destroyed(){
        this.$refs.scrollbar && this.$refs.scrollbar.$el.querySelector(".el-scrollbar__wrap").removeEventListener("scroll", this.onScroll)
    }
}
</script>
<style lang="scss">
.codelab-popper.ai-materials-popper{
    .tips{
        font-size: 14px;
        line-height: 1.5em;
        color: #ffffff;
    }
    .search-box{
        margin-top: 14px;
        position: relative;
        .keyword-inputer {
            height: 40px;
            .el-input__inner {
                background: #333333;
                border: none;
                line-height: 40px;
                height: 40px;
                border-radius: 4px 4px 0 0;
                color: #ffffff;
            }
        }
        .serch-suggestions{
            width: 100%;
            padding: 12px;
            border-radius: 0 0 4px 4px;
            position: absolute;
            left: 0;
            top: 41px;
            overflow: hidden;
            background: #333333;
            z-index: 2;
            .no-suggestion-tip{
                font-size: 14px;
                line-height: 1.25em;
                padding: 12px 4px;
                color: #a8a8ac;
            }
        }
    }
     
    .typed-material-list{
        width: 100%;
        height: 300px;
        margin-top: 12px;
        &>div{
            width: 100%;
            height: 100%;
        }
    }
    .ai-material-tag{
        margin: 4px 5px;
    }
    .el-dialog__footer {
        .footer-button-group {
            display: block;
            text-align: right;
            .popper-footer-button {
                margin-left: 18px;
            }
        }
    }
}
</style>